<div class="row container-group-register">
  <div class="container-login xs:col-12 lg:col-6 px-3 py-0">
    <app-header-login
      [class]="'login-register'"
      [showLabel]="false"
      [linkRegister]="false"
      [linkRecoverPassword]="false"
    />
  </div>

  <div class="container-register xs:col-12 lg:col-6 py-0 px-3">
    <app-register-visit
      (returnLoginEvent)="returnInvitado($event)"
      [innerWidth]="innerWidth"
      [invitado]="invitado"
    />
  </div>
</div>
